import imageDefault from '../images/remedy_coffee_2.webp'

export const onImageError = (e) => {
  e.target.onerror = null
  e.target.src = imageDefault
}
